export enum CIOTrackEventType {
	STUDY_VIEW = 'study_view',
	ORG_VIEW = 'organisation_view',
	AUTOMATION_UPDATE_SUBS = 'automation_update_subscriptions',
	FAVOURITE_ADDED = 'favourite_added',
	FAVOURITE_REMOVED = 'favourite_removed',
	SCHOLARSHIP_ELIGIBILITY = 'scholarship_eligibility'
}
